import { render } from "./Plan.vue?vue&type=template&id=c56bbfa6&scoped=true"
import script from "./Plan.vue?vue&type=script&lang=js"
export * from "./Plan.vue?vue&type=script&lang=js"

import "./Plan.vue?vue&type=style&index=0&id=c56bbfa6&lang=scss&scoped=true"

import exportComponent from "E:\\uni-app项目\\kxsns-master\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c56bbfa6"]])

export default __exports__